var spruceDisclaimer = {
	filterDisclaimers:function(){
		$(".js-disclaimer-link").each(function(){
			var did = parseInt($(this).data("disclaimer-trigger"));
			$("li[data-disclaimer-target="+did+"]").addClass("keep");
		});
		$("li[data-disclaimer-target]").each(function(){
			if(!$(this).hasClass("keep")){
				$(this).remove();
			}
		});
		if($("li[data-disclaimer-target]").length === 0){
			$("section.footer--disclaimers").hide();
		}
	},
	makeActive:function(id){
		$("li[data-disclaimer-target]").removeClass("active").find("button").remove();
		$("li[data-disclaimer-target] button").remove();
		$("li[data-disclaimer-target="+id+"]").addClass("active").prepend("<button aria-label='Back to content'></button>");
		var scrollTarget = $("li[data-disclaimer-target="+id+"]");
		var scrollOffset = -50;
		$('html, body').animate({scrollTop: scrollTarget.offset().top + (scrollOffset-$("header").height()) }, 400);
		$("li[data-disclaimer-target].active button").focus();
	},
	goback:function(){
		var scrollTarget = $("button.js-disclaimer-link.last-disclaimed");
		var scrollOffset = -50;
		$('html, body').animate({scrollTop: scrollTarget.offset().top + (scrollOffset-$("header").height()) }, 400);
		$("button.js-disclaimer-link.last-disclaimed").focus();
		$("li[data-disclaimer-target]").removeClass("active").find("button").remove();
		$("li[data-disclaimer-target] button").remove();
	}
}

$(document).ready(function(){
	spruceDisclaimer.filterDisclaimers();
})
.on("click", "button.js-disclaimer-link", function(e){
	e.preventDefault();
	$("button.js-disclaimer-link").removeClass("last-disclaimed");
	$(this).addClass("last-disclaimed");
	var disclaimerID = $(this).data("disclaimer-trigger");
	//console.log("The ID", disclaimerID);														
	spruceDisclaimer.makeActive(disclaimerID );
})
.on("click", "li[data-disclaimer-target].active button", function(e){
	e.preventDefault();
	spruceDisclaimer.goback();
})
;
